enum FileUploadStatusTypes {
  PENDING = "Pending",
  UPLOADED = "Uploaded",
  DUPLICATE = "Duplicate",
  FAILED = "Failed",
}

export default FileUploadStatusTypes